import { Injectable } from "@nestjs/common";
import { RmAntibioticsReportInfo } from "./rm-antibiotics-report.dto";
import { RmAntiBioticsTest } from "../rm-antibiotics-report.entity";

@Injectable()
export class RmAntiBioticsAdapter{
    public convertDtoToEntity(dtoInfo: RmAntibioticsReportInfo): RmAntiBioticsTest{
        const entity = new RmAntiBioticsTest;
        entity.grnId = dtoInfo.grnId;
        entity.grnItemId = dtoInfo.grnItemId;
        entity.productCode = dtoInfo.productCode;
        entity.lotNumber = dtoInfo.lotNumber;
        entity.deHeadingCenter = dtoInfo.deHeadingCenter;
        entity.sampleDetails = dtoInfo.sampleDetails;
        entity.count = dtoInfo.count;
        entity.noOfBoxes = dtoInfo.noOfBoxes;
        entity.productId = dtoInfo.productId;
        entity.plantId = dtoInfo.plantId;
        entity.CAPL = dtoInfo.CAPL;
        entity.CAP = dtoInfo.CAP;
        entity.AOZL = dtoInfo.AOZL;
        entity.AOZ = dtoInfo.AOZ;
        entity.AMOZL = dtoInfo.AMOZL;
        entity.AMOZ = dtoInfo.AMOZ;
        entity.SEM = dtoInfo.SEM;
        entity.AHD = dtoInfo.AHD;
        entity.remarks = dtoInfo.remarks;
        if(dtoInfo.infoId){
            entity.updatedUser = dtoInfo.updatedUser;
        }else{
            entity.createdUser = dtoInfo.createdUser;
        }
        return entity;
    }
}